{
  "nav": {
    "home": "Acasă",
    "services": "Servicii",
    "prices": "Prețuri",
    "projects": "Proiecte",
    "about": "Despre mine",
    "contact": "Contact",
    "email": "Email",
    "linkedin": "LinkedIn"
  },
  "backToProjects": "Înapoi la proiecte",
  "projectOverview": "Prezentare proiect",
  "overview": "Prezentare",
  "challenge": "Provocarea",
  "businessNeed": "Nevoia de afaceri",
  "philosophy": "Filosofia",
  "goal": "Obiectivul",
  "solution": "Soluția",
  "polestarLandingPage": "Pagina de destinație Polestar Live"
}

